import React, { Fragment, useContext } from "react";
import { Col, Row } from "reactstrap";
import ChatHeader from "./ChatHeader";
import SendChat from "./SendChat";
import ChatMessageList from "./ChatMessageList";

const Chatting = () => {
  return (
    <Fragment>
      <Row className="chat-box">
        <Col className="chat-right-aside">
          <div className="chat">
            <ChatHeader />
            <ChatMessageList />
            <SendChat />
          </div>
        </Col>
        {/* <Col className={`ps-0 chat-menu ${menuToggle ? 'show' : ''}`}>
          <ChatMenu />
        </Col> */}
      </Row>
    </Fragment>
  );
};
export default Chatting;
